import BaseRoute from "../../../../../../lib/itn-ui-kit/route/base-route";
import { service } from "../../../../../../lib/itn-ui-kit/services/service-container";

import Template from "./template";

export default class ClientCoverageRoute extends BaseRoute {
  @service("repositories/client-coverage-repository") clientCoverageRepository;
  @service("repositories/client-coverage-history-repository")
  clientCoverageHistoryRepository;

  element = (<Template />);
  revalidateOnParams = ["id"];

  async loader({ params }) {
    const { id } = params;

    if (!id || id === "undefined") {
      console.error("Case id not found");
      return { clientCoverage: null };
    } else {
      try {
        const clientCoverage = await this.clientCoverageRepository.findRecord(id, {
          noCache: true,
        });
        const clientCoverageHistory = await this.clientCoverageHistoryRepository.query({
          caseId: id,
        });
        return { clientCoverage, clientCoverageHistory };
      } catch (error) {
        return { clientCoverage: null };
      }
    }
  }
}
